import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import IconButton from 'material-ui/IconButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageIcon } from 'assets/materialIcons/materialIcons';
import { Link } from 'react-router-dom';

const EditButton = (props) => {
    const {
        buttonStyle,
        disabled,
        icon,
        label,
        style,
        translate,
        url,
    } = props;

    const linkStyle = {
        'textDecoration': 'none',
        'display': 'inline-flex',
    };

    const enhancedLinkStyle = Object.assign({}, linkStyle, style);

    if (disabled) {
        return (
            <IconButton
                tooltip={ translate('resources.orders.edit.no_longer_editable') }
                tooltipPosition='top-center'
                tooltipStyles={ {
                    left: '50%',
                    transform: 'translateX(-50%)',
                } }
                style={ {
                    boxSizing: 'content-box',
                    height: 'auto',
                    margin: 0,
                    padding: '8px',
                    width: 'auto',
                } }
                disableTouchRipple={ true }
                icon={ <ImageIcon color={ theme.palette.doveGray } /> }
            />
        );
    }

    return (
        <Link
            to={ url }
            style={ enhancedLinkStyle }
        >
            <Button
                icon={ icon ? icon : <ImageIcon color={ theme.palette.doveGray } /> }
                title={ label || translate('actions.edit') }
                style={ buttonStyle }
            />
        </Link>
    );
};

EditButton.defaultProps = {
    buttonStyle: {},
    style: {},
    url: '',
};

EditButton.propTypes = {
    buttonStyle: PropTypes.object,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    style: PropTypes.object,
    translate: PropTypes.func.isRequired,
    url: PropTypes.string,
    icon: PropTypes.element,
};

export default translate(EditButton);



// WEBPACK FOOTER //
// ./src/components/button/EditButton.js